import {
  Article,
  Baseline,
  Block,
  BlockHeadline,
  BlockList,
  BlockListItem,
  Blocks,
  Header,
  Headline,
  Image,
  KeyPoint,
  KeyPoints,
  KeyPointsTitle,
  Main,
  Subtitle,
  Title,
} from "./style";

import BackButton from "../../../components/BackButton";
import { Helmet } from "react-helmet";
import React from "react";
import image100 from "./images/100.png";
import image26 from "./images/26.png";
import image660000 from "./images/660000.png";
import image6d7 from "./images/6,7.png";
import image80000 from "./images/80000.png";
import imageClothes from "./images/clothes.jpg";
import imageGeoMarker from "./images/geo-marker.png";
import imageHandStars from "./images/hand-stars.png";
import imageOffice from "./images/office.jpg";
import imageShirt from "./images/shirt.png";
import imageShirtRecycle from "./images/shirt-recycle.png";
import imageTruckCheck from "./images/truck-check.png";
import imageUserStars from "./images/user-stars.png";
import imageWork from "./images/work.jpg";

export default function() {
  return (
    <Article
      aside={
        <KeyPoints>
          <KeyPointsTitle>Chiffres clés</KeyPointsTitle>
          <KeyPoint icon={imageUserStars} label={"ans d’expérience"}>
            <Image src={image100} alt="100" style={{ margin: -6 }} />
          </KeyPoint>
          <KeyPoint icon={imageGeoMarker} label={"sites en France"}>
            <Image src={image26} alt="26" style={{ margin: -6 }} />
          </KeyPoint>
          <KeyPoint icon={imageTruckCheck} label={"clients servis"}>
            <Image src={image80000} alt="80 000" style={{ margin: -6 }} />
          </KeyPoint>
          <KeyPoint icon={imageShirt} label={"personnes habillées"}>
            <Image src={image660000} alt="600 000" style={{ margin: -6 }} />
          </KeyPoint>
          <KeyPoint
            icon={imageShirtRecycle}
            label={"millions de vêtements en circulation"}
          >
            <Image src={image6d7} alt="6,7" style={{ margin: -6 }} />
          </KeyPoint>
        </KeyPoints>
      }
      backButton={<BackButton to="/" />}
    >
      <Helmet>
        <title>L'Expertise Netexial</title>
      </Helmet>
      <Header>
        <Headline icon={<Image src={imageHandStars} />}>
          <Title>
            L’Expertise Netexial, <em>gage de fiabilité</em>
          </Title>
          <Subtitle>
            Nos solutions 100% expertes pour vos textiles professionnels
          </Subtitle>
        </Headline>
        <Baseline>
          Notre objectif&nbsp;? Vous donner satisfaction à chaque étape
        </Baseline>
      </Header>
      <Main>
        <Blocks>
          <Block image={imageWork}>
            <BlockHeadline>
              Votre image professionnelle <em>est valorisée</em>
            </BlockHeadline>
            <BlockList>
              <BlockListItem>
                Nos collections de tenues professionnelles, de linge hôtelier et
                de linge de restauration{" "}
                <strong>s’adaptent à la diversité de vos métiers</strong> et{" "}
                <strong>reflètent l’image que vous souhaitez donner</strong>.
              </BlockListItem>
              <BlockListItem>
                Nos articles <strong>certifiés et personnalisables</strong>{" "}
                garantissent une allure impeccable et durable pour vos équipes.
              </BlockListItem>
              <BlockListItem>
                Les réparations et remplacements sont effectués{" "}
                <strong>
                  automatiquement pour préserver la qualité et l’image de votre
                  marque
                </strong>
                .
              </BlockListItem>
            </BlockList>
          </Block>
          <Block image={imageOffice}>
            <BlockHeadline>
              Notre prise en charge
              <em>est complète et réactive</em>
            </BlockHeadline>
            <BlockList>
              <BlockListItem>
                Nos équipes d’experts dédiés assurent un{" "}
                <strong>suivi attentif et personnalisé</strong>, disponibles à
                chaque instant pour répondre à vos demandes.
              </BlockListItem>
              <BlockListItem>
                Votre outil <strong>Mon Espace client Netexial</strong>, simple
                et sécurisé, vous permet de{" "}
                <strong>piloter vos prestations 24h/24</strong> : livraisons,
                stocks, commandes, factures… tout est à portée de clic.
              </BlockListItem>
            </BlockList>
          </Block>
          <Block image={imageClothes}>
            <BlockHeadline>
              Le budget est clair
              <em>et maîtrisé</em>
            </BlockHeadline>
            <BlockList>
              <BlockListItem>
                Un budget <strong>défini avec transparence</strong>, sans
                surprise.
              </BlockListItem>
              <BlockListItem>
                Les coûts d’investissement, d’amortissement et de stockage sont{" "}
                <strong>pris en charge par Netexial</strong>.
              </BlockListItem>
            </BlockList>
          </Block>
        </Blocks>
      </Main>
    </Article>
  );
}
